import { FC } from "react"
import {themeStore, IStatistics, DexStatistics, LowerInfoProps} from "@root/common"
import { LowerInfoStyled } from "./LowerInfo.styled"
import { observer } from "mobx-react-lite"
import Row, { makeNumber } from "./Row/Row"


interface ILowerInfo {
    statistics?: DexStatistics
}

const LowerInfo: FC<LowerInfoProps> = observer((props) => {
  const {statistics} = props as ILowerInfo

  return (
      <LowerInfoStyled>
        {statistics?.longShort === "short"
          ? <>
            <Dex statistics={statistics}/>
            <OrderBook statistics={statistics}/>
          </>
          : <>
            <OrderBook statistics={statistics}/>
            <Dex statistics={statistics}/>
          </>
        }
      </LowerInfoStyled>
  )
})

const OrderBook = (props: ILowerInfo) => {
  const {statistics} = props
  return (
    <>
      {statistics &&
          <div>
              <div className="headers">
                  <h3 style={{ color: themeStore.textColor }}>Цена</h3>
                  <h3 style={{ color: themeStore.textColor }}>Объем $</h3>
              </div>

              {[...(statistics.orderbook?.asks || [])]?.reverse()?.map((ask, i) =>
                  <Row
                      key={Math.random()}
                      price={ask.price}
                      volume={ask.volume}
                      color={themeStore.redColor}
                      width={100 * parseInt(ask.volume) / Math.max(...(statistics.orderbook?.asks?.map(ask => parseInt(ask.volume)) || []))}
                  />
              )}

              {statistics.orderbook?.bids?.map((bid, i) =>
                  <Row
                      key={Math.random()}
                      price={bid.price}
                      volume={bid.volume}
                      color={themeStore.greenColor}
                      width={100 * parseInt(bid.volume) / Math.max(...(statistics.orderbook?.bids?.map(bid => parseInt(bid.volume)) || []))}
                  />
              )}
          </div>
      }
    </>
  )
}

const Dex = (props: ILowerInfo) => {
  const {statistics} = props
  return (
    <>
      {statistics &&
        <div>
          <h3 style={{ color: themeStore.textColor }}>Цена</h3>
          <p style={{borderColor: themeStore.textColor,color: themeStore.textColor,border: "1px solid", borderRadius: "1em", padding: "1em 1em"}}>{makeNumber(parseFloat(statistics.dexRate))}</p>
          <span></span>
        </div>
      }
    </>
  )
}

export default LowerInfo
